import { Helmet } from 'react-helmet-async'
import {
  FEATURED_IMAGE, FEATURED_IMAGE_HEIGHT, FEATURED_IMAGE_TYPE, FEATURED_IMAGE_WIDTH,
} from '@/content/siteImages'

/**
 * DefaultSEO - Sets default Open Graph and Twitter Card meta tags
 * These tags ensure the featured image appears when any page is shared on social media.
 * Individual pages can override title/description, but will inherit these image tags.
 */
export default function DefaultSEO() {
  const featuredImage = FEATURED_IMAGE
  const defaultTitle = 'SuperSchema | Make your HubSpot website ready for AI'
  const defaultDescription = 'SuperSchema shows what AI systems can understand from your website and gives you tools to make the important parts clearer.'

  return (
    <Helmet>
      {/* Default Open Graph Tags */}
      <meta property="og:site_name" content="Super Schema" />
      <meta property="og:image" content={featuredImage} />
      <meta property="og:image:secure_url" content={featuredImage} />
      <meta property="og:image:type" content={FEATURED_IMAGE_TYPE} />
      <meta property="og:image:width" content={FEATURED_IMAGE_WIDTH} />
      <meta property="og:image:height" content={FEATURED_IMAGE_HEIGHT} />
      <meta property="og:image:alt" content={defaultTitle} />

      {/* Default Twitter Card Tags */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:image" content={featuredImage} />
      <meta name="twitter:site" content="@superschemaai" />

      {/* Fallback meta tags (will be overridden by page-specific Helmet) */}
      <meta property="og:title" content={defaultTitle} />
      <meta property="og:description" content={defaultDescription} />
      <meta name="twitter:title" content={defaultTitle} />
      <meta name="twitter:description" content={defaultDescription} />
    </Helmet>
  )
}
